import type { ICandidateOnsiteInterviewEntity } from '~/domain/PermanentJobs';
import type { TShiftCardData } from '~/types/ShiftCard';
import { computeHours, formatRate, parseCardDate, resolveProfession } from '~/utils/shiftCard';
import { toInterviewCardStatus } from '../../candidateDetailsView';

/**
 * One of the candidate's onsite interviews → the DS `DentalOfficeShiftCard`.
 *
 * No `candidates` stack on the confirm card: the endpoint returns only
 * `candidatesAppliedCount`, not who the other applicants are.
 */
export const mapCandidateInterviewToShiftCard = (
  interview: ICandidateOnsiteInterviewEntity,
  officeName: string,
): TShiftCardData => ({
  status: toInterviewCardStatus(interview.onsiteInterviewStatus),
  date: parseCardDate(interview.localDate),
  startTime: interview.localStartTime,
  endTime: interview.localEndTime,
  hours: computeHours(interview.localStartTime, interview.localEndTime),
  rate: formatRate(interview.rate),
  profession: resolveProfession(interview.profession),
  office: officeName,
  interview: true,
});
